import { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaCircleUser } from "react-icons/fa6";
import { TbMenu2 } from "react-icons/tb";
import { useAuthContext } from "../../context/AuthContext";
import LoginModal from "../../modals/LoginModal/LoginModal";
import SignupModal from "../../modals/SignupModal/SignupModal";

import "./header.scss";

const logo_white = require("../../assets/logo-white.png");

const Header = ({ onHome = false }) => {
  const menuRef = useRef(null);
  const { isLogin } = useAuthContext();

  const [visibleMenu, setVisibleMenu] = useState(false);
  const [visibleLogin, setVisibleLogin] = useState(false);
  const [visibleSignup, setVisibleSignup] = useState(false);

  useEffect(() => {
    const menuHandler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setVisibleMenu(false);
      }
    };

    document.addEventListener("click", menuHandler);
    return () => document.removeEventListener("click", menuHandler);
  }, []);

  const navItems = [
    { label: "ОНЛАЙН СУРГАЛТ", path: "/courses/advanced/list" },
    { label: "МЭДЭЭ, МЭДЭЭЛЭЛ", path: "/news" },
    { label: "ТЭТГЭЛЭГ", path: "/scholarship" },
    { label: "ХОЛБОО БАРИХ", path: "/contact" },
  ];

  return (
    <header className={`header ${onHome ? "header--home" : "noneHome"}`}>
      <LoginModal
        visible={visibleLogin}
        setVisible={setVisibleLogin}
        onOpenSignup={() => setVisibleSignup(true)}
      />
      <SignupModal visible={visibleSignup} setVisible={setVisibleSignup} />

      {onHome && (
        <div className="header-premium-wrap">
          <div className="header-premium">
            <div className="header-premium__inner">
              <Link to="/" className="header-premium__brand">
                <img
                  src={logo_white}
                  alt="Ochiroo's Theory"
                  className="header-premium__brand__logo"
                />
              </Link>

              <nav className="header-premium__nav">
                {navItems.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      `header-premium__nav-link ${isActive ? "active" : ""}`
                    }
                  >
                    {item.label}
                  </NavLink>
                ))}
              </nav>

              <div className="header-premium__actions">
                {isLogin ? (
                  <Link to="/account" className="header-premium__account">
                    <FaCircleUser size={28} />
                  </Link>
                ) : (
                  <>
                    <button
                      className="header-premium__login"
                      onClick={() => setVisibleLogin(true)}
                    >
                      НЭВТРЭХ
                    </button>

                    <button
                      className="header-premium__signup"
                      onClick={() => setVisibleSignup(true)}
                    >
                      БҮРТГҮҮЛЭХ
                    </button>
                  </>
                )}

                {/* <button
                  className="header-premium__search"
                  aria-label="search"
                  onClick={() => navigate("/news")}
                >
                  <FiSearch size={22} />
                </button> */}

                <button
                  ref={menuRef}
                  className="header-premium__menu-btn"
                  onClick={() => setVisibleMenu((prev) => !prev)}
                  aria-label="menu"
                >
                  <TbMenu2 size={24} />
                </button>
              </div>
            </div>

            <div
              className={`header-premium__mobile-menu ${
                visibleMenu ? "show" : ""
              }`}
            >
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `header-premium__mobile-link ${isActive ? "active" : ""}`
                  }
                  onClick={() => setVisibleMenu(false)}
                >
                  {item.label}
                </NavLink>
              ))}

              {!isLogin && (
                <div className="header-premium__mobile-actions">
                  <button
                    className="header-premium__mobile-login"
                    onClick={() => {
                      setVisibleMenu(false);
                      setVisibleLogin(true);
                    }}
                  >
                    НЭВТРЭХ
                  </button>

                  <button
                    className="header-premium__mobile-signup"
                    onClick={() => {
                      setVisibleMenu(false);
                      setVisibleSignup(true);
                    }}
                  >
                    БҮРТГҮҮЛЭХ
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
